import { render } from "./third-comp.vue?vue&type=template&id=e75eb37e&scoped=true"
import script from "./third-comp.vue?vue&type=script&lang=js"
export * from "./third-comp.vue?vue&type=script&lang=js"

import "./third-comp.vue?vue&type=style&index=0&id=e75eb37e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e75eb37e"]])

export default __exports__